// Fonte única da versão do front-end: o campo "version" do package.json.
//
// Antes isso vivia em REACT_APP_VERSION_FRONT no .env — que é gitignored, então a
// versão exibida dependia do arquivo local de quem fez o build (e já tinha divergido
// do package.json). Importar daqui garante que só existe um número para incrementar.
//
// Para subir a versão: `npm version patch|minor|major` — ele atualiza o package.json,
// faz o commit e cria a tag no mesmo formato dos commits existentes (v1.6.0).
// Import default (não `import { version }`): o webpack do CRA trata JSON como
// módulo de export default e quebra o build com named imports.
import packageJson from "../../package.json";

export const APP_VERSION = `v${packageJson.version}`;
